import { http } from '@/api/client/httpClient';
import type { PagedResult } from '@/api/types/abp';
import type {
  SelectListItem,
  TraderSurveillanceAlertDto,
  TsAlertCountsDto,
  TsAlertFilterDto,
  TsAlertInfoDto,
  TsAlertOperationInput,
  TsAlertTradeRowDto,
  TsAuditTrailRowDto,
  TsResolveAllInput,
} from '@/api/types/traderSurveillance';

// ABP conventional-controller mapping of SuspiciousTradesAppService: the "Get"
// verb prefix is stripped, the remainder is kebab-cased, non-Get verbs POST.
const BASE = '/api/app/suspicious-trades';

export const suspiciousTradesApi = {
  getProfileTagOptions: () =>
    http.get<SelectListItem[]>(`${BASE}/profile-tag-options`).then((r) => r.data),

  getPendingAlertCount: () =>
    http.get<number>(`${BASE}/pending-alert-count`).then((r) => r.data),

  getAlerts: (input: TsAlertFilterDto) =>
    http.get<PagedResult<TraderSurveillanceAlertDto>>(`${BASE}/alerts`, { params: input }).then((r) => r.data),

  getAlertCounts: (input: TsAlertFilterDto) =>
    http.get<TsAlertCountsDto>(`${BASE}/alert-counts`, { params: input }).then((r) => r.data),

  getAlertInfo: (alertId: number) =>
    http.get<TsAlertInfoDto>(`${BASE}/alert-info`, { params: { alertId } }).then((r) => r.data),

  getAlertTradeRows: (alertId: number) =>
    http.get<TsAlertTradeRowDto[]>(`${BASE}/alert-trade-rows`, { params: { alertId } }).then((r) => r.data),

  getAuditTrail: (alertId: number) =>
    http.get<TsAuditTrailRowDto[]>(`${BASE}/audit-trail`, { params: { alertId } }).then((r) => r.data),

  resolveAll: (input: TsResolveAllInput) =>
    http.post<void>(`${BASE}/resolve-all`, input).then((r) => r.data),

  resolveAlert: (input: TsAlertOperationInput) =>
    http.post<string>(`${BASE}/resolve-alert`, input).then((r) => r.data),

  reopenAlert: (input: TsAlertOperationInput) =>
    http.post<string>(`${BASE}/reopen-alert`, input).then((r) => r.data),

  postComment: (input: TsAlertOperationInput) =>
    http.post<string>(`${BASE}/post-comment`, input).then((r) => r.data),
};
